export enum Month {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export enum WeekDay {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}

const MonthsWithDays = new Map();
MonthsWithDays.set(Month.January, 31);
MonthsWithDays.set(Month.February, 29);
MonthsWithDays.set(Month.March, 31);
MonthsWithDays.set(Month.April, 30);
MonthsWithDays.set(Month.May, 31);
MonthsWithDays.set(Month.June, 30);
MonthsWithDays.set(Month.July, 31);
MonthsWithDays.set(Month.August, 31);
MonthsWithDays.set(Month.September, 30);
MonthsWithDays.set(Month.October, 31);
MonthsWithDays.set(Month.November, 30);
MonthsWithDays.set(Month.December, 31);
export { MonthsWithDays };
